import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Save, Trash2 } from 'lucide-react';
import { cn } from '../../utils/cn';

export default function ReviewTemplateEditor({ template, onSave, onDelete, saving }) {
  const { t } = useTranslation();
  const [subject, setSubject] = useState(template.subject);
  const [body, setBody] = useState(template.body);
  const [isActive, setIsActive] = useState(template.is_active);

  useEffect(() => {
    setSubject(template.subject);
    setBody(template.body);
    setIsActive(template.is_active);
  }, [template]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ subject, body, is_active: isActive });
  };

  return (
    <form onSubmit={handleSubmit} className="px-6 py-4 space-y-4">
      <div>
        <label htmlFor="review-subject" className="block text-sm font-medium text-gray-700 mb-1">
          {t('review_templates.subject')}
        </label>
        <input
          id="review-subject"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
          maxLength={255}
          className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
        />
      </div>

      <div>
        <label htmlFor="review-body" className="block text-sm font-medium text-gray-700 mb-1">
          {t('review_templates.body')}
        </label>
        <textarea
          id="review-body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          required
          rows={14}
          className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 font-mono text-sm"
        />
        <p className="mt-1 text-xs text-gray-500">{t('review_templates.body_hint')}</p>
      </div>

      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
            className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
          {t('review_templates.is_active')}
        </label>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onDelete}
            className="flex items-center gap-1.5 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg font-medium transition-colors"
          >
            <Trash2 className="h-4 w-4" />
            {t('common.delete')}
          </button>
          <button
            type="submit"
            disabled={saving}
            className={cn(
              'flex items-center gap-1.5 px-4 py-2 bg-primary-600 text-white rounded-lg font-medium transition-colors',
              saving ? 'opacity-50' : 'hover:bg-primary-700'
            )}
          >
            <Save className="h-4 w-4" />
            {t('common.save')}
          </button>
        </div>
      </div>
    </form>
  );
}
